import React, { Component } from "react";
import { Router, Route, Switch } from "react-router-dom";
import { createBrowserHistory } from "history";
import "./App.scss";
import Auth from "./services/authentication";
import AuthRoute from "./components/AuthRoute";
import get from "utils/get";
import apm from "utils/ApplicationMonitoring";

const auth = new Auth();

window.onload = function() {
  setTimeout(() => {
    auth.isAuthenticated().then(authenticated => {
      if (authenticated) {
        let token = auth.getAccessTokenPayload();

        const accountId = localStorage.getItem("activeAccountId");
        const email = token["https://reactive.energy/email"];
        const accounts = localStorage.getItem("accounts");
        let accountName = "";
        if (typeof accounts === "string" && accounts.length) {
          const accountsArray = JSON.parse(accounts);
          const activeAccount = accountsArray.find(
            account =>
              parseInt(account.accountId, 10) === parseInt(accountId, 10)
          );
          accountName = get(activeAccount, "accountName");
        }

        apm.setUserContext({
          id: accountId,
          email: email,
          name: accountName
        });
      }
    });
  }, 2000);
};

const customHistory = createBrowserHistory();

const loading = () => (
  <div className="animated fadeIn pt-3 text-center">Loading...</div>
);

// Containers
const DefaultLayout = React.lazy(() => import("./containers/DefaultLayout"));

// Pages
const Login = React.lazy(() => import("./pages/Login"));
const Register = React.lazy(() => import("./pages/Register"));
const Page404 = React.lazy(() => import("./pages/Page404"));
const Page500 = React.lazy(() => import("./pages/Page500"));

class App extends Component {
  render() {
    return (
      <Router history={customHistory}>
        <React.Suspense fallback={loading()}>
          <Switch>
            <Route
              exact
              path="/login"
              name="Login Page"
              render={props => <Login {...props} />}
            />
            <Route
              exact
              path="/register"
              name="Register Page"
              render={props => <Register {...props} />}
            />
            <Route
              exact
              path="/404"
              name="Page 404"
              render={props => <Page404 {...props} />}
            />
            <Route
              exact
              path="/500"
              name="Page 500"
              render={props => <Page500 {...props} />}
            />
            <AuthRoute
              path="/"
              name="Home"
              render={props => <DefaultLayout {...props} />}
            />
          </Switch>
        </React.Suspense>
      </Router>
    );
  }
}

export default App;
